import {
  TCustomerAccountOnboardRequestSchema,
  TCustomerAccountOnboardResponseSchema,
} from "@zeal/common";
import { AxiosError } from "axios";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";

export const customerAccountOnboard =
  (axios: IAxiosInstance) =>
  async (body: TCustomerAccountOnboardRequestSchema) => {
    try {
      const response = await axios.noRetry.post<
        IApiResponse<TCustomerAccountOnboardResponseSchema>
      >(`/api/customer-accounts`, body);
      return response;
    } catch (e) {
      const errorMessage =
        (e as AxiosError)?.response?.data ??
        "Error onboarding customer account";
      throw errorMessage;
    }
  };
